import connect from './reduxConnect';
import component from './component';
import { actions, constants } from './redux';

export { actions, constants };

export default connect(component);
